import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import { Link } from "react-router-dom";
import React from "react";

const ReferrerCodeContent = ({
  searchBy,
  setSearchByValue,

  setSearchBy,
  // searchByValuePlaceholder,
  searchByValue,
  searchFilter,
  resetFilter,
}) => {
  let searchByValuePlaceholder = "";
  if (searchBy === "name") {
    searchByValuePlaceholder = "Amit Pandit";
  } else if (searchBy === "code") {
    searchByValuePlaceholder = "AM123";
  } else {
    searchByValuePlaceholder = "Pandit";
  }
  return (
    <>
      <Card>
        <CardBody>
          <Row>
            <Col lg="3" className="form-input-padding">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Search by
                </label>
                <Input
                  id="exampleFormControlSelect1"
                  style={{ height: "27px" }}
                  type="select"
                  value={searchBy}
                  onChange={(e) => {
                    setSearchByValue("");
                    setSearchBy(e.target.value);
                  }}
                >
                  <option value="name">Name</option>
                  <option value="code">Code</option>
                </Input>
              </FormGroup>
            </Col>
            <Col lg="3" className="form-input-padding">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  Search for
                </label>
                <Input
                  id="example3cols2Input"
                  placeholder={searchByValuePlaceholder}
                  type="text"
                  style={{    height: "27px"}}
                  onKeyPress={(e) => e.charCode === 13}
                  onChange={(e) => {
                    setSearchByValue(e.target.value && e.target.value.trim());
                  }}
                  value={searchByValue}
                />
              </FormGroup>
            </Col>
            <Col
              lg="1"
              style={{ marginTop: "9px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    type="button"
                    style={{
                      width: "100%",
                      background: "#e91d24",
                      color: "white",
                      height: "26px",
                      border: "1px solid rgb(233, 29, 36)",
                    }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => searchFilter(true)}
                  >
                    <div>
                      <i class="fas fa-search"></i>
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>

            <Col
              lg="1"
              style={{ marginTop: "9px", padding: "0px 6px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    color="light"
                    type="button"
                    style={{ width: "100%", height: "26px" }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => resetFilter()}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      <i class="fas fa-redo-alt 2px"></i> Reset
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>

            <Col
              lg="1"
              style={{ marginTop: "8px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Link
                    style={{ color: "black" }}
                    to={{
                      pathname: "/admin/CreateNewCode",
                    }}
                  >
                    <Button
                      color="primary"
                      type="button"
                      style={{ height: "26px" }}
                      id="example3cols2Input"
                    >
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        Create New Code
                      </div>
                    </Button>
                  </Link>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default ReferrerCodeContent;
